// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import pino from 'pino';

const createLogger = (service: string, options: pino.LoggerOptions = {}) =>
  options.browser !== undefined
    ? pino({ ...options, base: { service } })
    : pino({ ...options, base: { service } }, pino.destination(1));

const browserOptions =
  // eslint-disable-next-line
  typeof window === 'undefined' && typeof origin === 'undefined' ? {} : { browser: { asObject: true } };

export const coreLogger = createLogger('core', browserOptions);
export const serverLogger = createLogger('server', browserOptions);
export const utilsLogger = createLogger('utils', browserOptions);
export const topLevelLogger = createLogger('compiler', browserOptions);

/*
  hacky way to get the web console logs hidden besides errors
  the client/web doesn't seem to inherit the logLevels we set in a .seedplannerrc
  I suspect there is somewhere in the client code we should call setLogLevel
*/
export const clientLogger = createLogger('client', { level: 'error', ...browserOptions });

// eslint-disable-next-line
let loggers: ReadonlyArray<pino.Logger> = [clientLogger, coreLogger, serverLogger, utilsLogger, topLevelLogger];
export const setGlobalLogLevel = (level: pino.LevelWithSilent) => {
  for (const logger of loggers) {
    logger.level = level;
  }
};

export const createChild = (
  parent: pino.Logger,
  bindings: {
    readonly level?: pino.LevelWithSilent | string;
    // biome-ignore lint/suspicious/noExplicitAny: <explanation>
    readonly [key: string]: any;
  },
) => {
  const child = parent.child(bindings);
  loggers = loggers.concat(child);

  return child;
};
